import { useCallback } from 'react';
import axios from '../services/axios';

const useRefresh = (setAccessToken: (token: string) => void) => {
  const refresh = useCallback(async () => {
    const { data } = await axios.get('refresh', {
      withCredentials: true,
    });
    setAccessToken(data);
    return data;
  }, [setAccessToken]);
  return refresh;
};

export default useRefresh;
